import React from 'react';
import { connect } from 'react-redux';
import { fetchIdPhotoIfNeeded } from 'registration/creative/ducks';
import { cancelPhoneVerification, resendPhoneVerification } from 'common/ducks/user';
import WaitIdCapture from 'registration/creative/components/wait_id_capture';

const mapStateToProps = ({creativeRegistration: {idPhoto, selfie, idVerificationSubmmitedAt}}) => ({
  idPhoto,
  selfie,
  submittedAt: idVerificationSubmmitedAt
})

export default connect(mapStateToProps, {
  fetchIdPhotoIfNeeded,
  cancelPhoneVerification,
  resendPhoneVerification
})(WaitIdCapture);



// WEBPACK FOOTER //
// ./registration/creative/containers/wait_id_capture.jsx